import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../../../assets/js/LanguageContext';

const STEPS = ['setup_step_dates', 'setup_step_questions', 'setup_step_preview'];

const TemplateSteps = ({ current = 1 }) => {
  const { t } = useLanguage();

  return (
    <ol className="tp-steps" aria-label={t('setup_steps_label')}>
      {STEPS.map((key, index) => {
        const number = index + 1;
        const state = number < current ? 'is-done' : number === current ? 'is-current' : '';
        return (
          <li key={key} className={`tp-steps__item ${state}`.trim()}>
            <span className="tp-steps__num" aria-hidden="true">
              {number < current ? <Check size={13} strokeWidth={3} /> : number}
            </span>
            <span className="tp-steps__label">{t(key)}</span>
          </li>
        );
      })}
    </ol>
  );
};

export default TemplateSteps;
